import { useState } from 'react'

import { GuestInboxTimelineAttachment } from '@new/domains/operations/components/StayTimeline/StayTimeline.types'

import { AttachmentItem } from './components/AttachmentItem'
import { AttachmentViewer } from './components/AttachmentViewer'
import { useAttachmentDownload } from './hooks/useAttachmentDownload'
import { useStableAttachmentUrls } from './hooks/useStableAttachmentUrls'
import * as S from './MessageAttachments.styles'
import { AttachmentKind, getAttachmentKind, sortByKind } from './MessageAttachments.utils'

interface MessageAttachmentsProps {
  isInbound: boolean
  attachments?: GuestInboxTimelineAttachment[] | null
}

export const MessageAttachments = ({ isInbound, attachments }: MessageAttachmentsProps) => {
  const [viewerId, setViewerId] = useState<string | null>(null)

  const { getUrl, hasFailed, handleLoadError } = useStableAttachmentUrls()
  const { isDownloading, download } = useAttachmentDownload()

  if (!attachments?.length) return null

  const getShownKind = (attachment: GuestInboxTimelineAttachment): AttachmentKind => {
    return hasFailed(attachment) ? 'file' : getAttachmentKind(attachment)
  }

  const sortedAttachments = sortByKind(attachments, getShownKind)
  const images = sortedAttachments.filter(attachment => getShownKind(attachment) === 'image')
  const viewerIndex = images.findIndex(image => image.id === viewerId)

  return (
    <>
      <S.List $isInbound={isInbound}>
        {sortedAttachments.map(attachment => (
          <div key={attachment.id}>
            <AttachmentItem
              attachment={attachment}
              kind={getShownKind(attachment)}
              src={getUrl(attachment)}
              isDownloading={isDownloading(attachment)}
              onOpen={() => setViewerId(attachment.id)}
              onDownload={() => download(attachment)}
              onLoadError={() => handleLoadError(attachment)}
            />
          </div>
        ))}
      </S.List>

      {viewerIndex >= 0 ? (
        <AttachmentViewer
          images={images}
          index={viewerIndex}
          getUrl={getUrl}
          isDownloading={isDownloading}
          onDownload={download}
          onIndexChange={index => setViewerId(images[index].id)}
          onClose={() => setViewerId(null)}
        />
      ) : null}
    </>
  )
}
